import React from 'react';
import { formatCurrency } from '../utils/formatCurrency';
interface DescriptionDetail {
  label: string;
  value: string;
}
interface ExchangeOrderItem {
  itemNumber: number;
  itemType: string;
  description: DescriptionDetail[];
  passengers: string[];
  unitPrice: number;
  currency: string;
  quantity: number;
  tax: number;
  amount: number;
}
interface ExchangeOrderLineItemsProps {
  items: ExchangeOrderItem[];
}
export function ExchangeOrderLineItems({
  items
}: ExchangeOrderLineItemsProps) {
  return <div className="mb-6" data-id="element-369">
      {/* Table Header */}
      <div className="grid grid-cols-12 gap-3 pb-2.5 border-b-2 border-neutral-300 mb-3" data-id="element-370">
        <div className="col-span-5 text-xs font-semibold text-neutral-700 uppercase tracking-wide" data-id="element-371">
          Item / Description / Passenger
        </div>
        <div className="col-span-1 text-xs font-semibold text-neutral-700 text-right uppercase tracking-wide" data-id="element-372">
          Unit Price
        </div>
        <div className="col-span-1 text-xs font-semibold text-neutral-700 text-right uppercase tracking-wide" data-id="element-373">
          Currency
        </div>
        <div className="col-span-1 text-xs font-semibold text-neutral-700 text-center uppercase tracking-wide" data-id="element-374">
          Qty
        </div>
        <div className="col-span-2 text-xs font-semibold text-neutral-700 text-right uppercase tracking-wide" data-id="element-375">
          Tax
        </div>
        <div className="col-span-2 text-xs font-semibold text-neutral-700 text-right uppercase tracking-wide" data-id="element-376">
          Amount
        </div>
      </div>

      {/* Line Items */}
      {items.map((item, index) => <div key={index} className="grid grid-cols-12 gap-3 border-b border-neutral-200 py-4 last:border-b-0" data-id="element-377">
          {/* Column 1: Stacked Content Block */}
          <div className="col-span-5 space-y-3" data-id="element-378">
            {/* Item Number and Type */}
            <p className="font-bold text-sm text-neutral-900" data-id="element-379">
              {item.itemNumber}. {item.itemType}
            </p>

            {/* Description Block */}
            <div className="pl-3 border-l-2 border-neutral-200 space-y-1" data-id="element-380">
              {item.description.map((detail, detailIndex) => <div key={detailIndex} className="flex text-xs" data-id="element-381">
                  <span className="text-neutral-500 font-medium min-w-[110px]" data-id="element-382">
                    {detail.label}:
                  </span>
                  <span className="text-neutral-700" data-id="element-383">{detail.value}</span>
                </div>)}
            </div>

            {/* Passenger Block */}
            {item.passengers.length > 0 && <div className="pl-3 border-l-2 border-blue-200 bg-blue-50/30 py-2" data-id="element-384">
                <p className="text-xs font-semibold text-neutral-700 mb-1" data-id="element-385">
                  Passenger(s):
                </p>
                <div className="space-y-0.5" data-id="element-386">
                  {item.passengers.map((passenger, passengerIndex) => <p key={passengerIndex} className="text-xs text-neutral-900 font-medium" data-id="element-387">
                      {passenger}
                    </p>)}
                </div>
              </div>}
          </div>

          {/* Column 2: Unit Price */}
          <div className="col-span-1 text-right text-xs text-neutral-900 tabular-nums self-start pt-1" data-id="element-388">
            {formatCurrency(item.unitPrice)}
          </div>

          {/* Column 3: Currency */}
          <div className="col-span-1 text-right text-xs text-neutral-700 font-semibold self-start pt-1" data-id="element-389">
            {item.currency}
          </div>

          {/* Column 4: Quantity */}
          <div className="col-span-1 text-center text-xs text-neutral-900 tabular-nums self-start pt-1" data-id="element-390">
            {item.quantity}
          </div>

          {/* Column 5: Tax */}
          <div className="col-span-2 text-right text-xs text-neutral-900 tabular-nums self-start pt-1" data-id="element-391">
            {formatCurrency(item.tax)}
          </div>

          {/* Column 6: Amount */}
          <div className="col-span-2 text-right text-sm font-semibold text-neutral-900 tabular-nums self-start pt-1" data-id="element-392">
            {formatCurrency(item.amount)}
          </div>
        </div>)}
    </div>;
}